import { render, staticRenderFns } from "./UserSalePieChart.vue?vue&type=template&id=676645f1&scoped=true&"
import script from "./UserSalePieChart.vue?vue&type=script&lang=js&"
export * from "./UserSalePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676645f1",
  null
  
)

export default component.exports